<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <div class="flex rounded text-xs w-max ">

                    </div>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Taxas
                </h2>
            </div>
        </template>
         <div class="mt-4 pb-2">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="py-4 grid grid-cols-5 gap-4 ">
                    <div class="col-span-2">
                        <div class="inline-flex rounded-md shadow-sm mt-4" role="group">
                            <div>
                                <button :disabled="disabled" class="my-5 items-center px-4 py-1 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                                    @click="requestReport('xlsx')">
                                    <i class="fas fa-file-csv"></i>
                                    Exportar XLSX
                                </button>
                                <button :disabled="disabled" class="my-5 items-center px-4 py-1 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                                    @click="requestReport('pdf')">
                                    <i class="fas fa-file-pdf"></i>
                                    Exportar PDF
                                </button>
                            </div>
                        </div>
                        <br />
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Ver como:
                        </label>

                        <div class="inline-flex rounded-md shadow-sm" role="group">
                            <button type="button" :class="isClient ? 'bg-gray-100 text-gray-900' : 'bg-gray-700 text-white'" @click="changeClient(false)" class="py-2 px-4 text-sm font-medium bg-white rounded-l-lg border border-gray-200 ">
                                Admin
                            </button>
                            <button type="button" :class="!isClient ? 'bg-gray-100 text-gray-900' : 'bg-gray-700 text-white'" @click="changeClient(true)" class="py-2 px-4 text-sm font-medium bg-white rounded-r-md border border-gray-200">
                                Cliente
                            </button>
                        </div>
                    </div>
                    <div class="col-span-3">
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Tabelas
                        </label>
                        <jet-auto-complete
                            id="contact" class="mt-1 block w-full"
                            :endpoint="'taxes'"
                            :auto-load="true"
                            :custom-option="customTablesView"
                            v-model="tableSelect"
                        />
                    </div>
                </div>
                
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout';
import Welcome from './../../Jetstream/Welcome';
import Dropdown from '../../Jetstream/Dropdown';
import DropdownLink from '../../Jetstream/DropdownLink';
import JetAutoComplete from '../../Jetstream/AutoComplete';
import Flash from '../../Helpers/Flash';
import TgoWidget from '../../Helpers/Widget';

export default {
    components: {
        TgoWidget,
        Dropdown,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete
    },
    props: ['tables', 'reports'],
    data() {
        return {
            tableSelect: null,
            isClient: true,
            disabled: false
        }
    },
    methods: {
        customTablesView(option) {
            var name = option.name;
            var scopes = option.scope || [];

            scopes = scopes.map(scope => this.scopes[scope]).join(', ');

            return `
                <div class="flex items-center">
                    <div class="ml-3">
                        <div class="text-xs leading-none font-medium text-gray-900">${name}</div>
                        <div class="text-xs leading-none text-gray-500">${scopes}</div>
                    </div>
                </div>
            `;

        },
        changeClient(status) {
            this.isClient = status;
        },
        async requestReport(type) {
            if (this.tableSelect == null) {
                  this.$toast.open({
                    message: 'Por favor, selecione uma tabela.',
                    type: 'warning',
                    duration: 5000,
                    position: 'top-right',
                    showCloseButtonOnHover: true
                });
                return;
            }

            this.disabled = true;

            let endpoint = '/acquiring/export/taxes';

            let data = {
                id: this.tableSelect.id,
                name: this.tableSelect.name,
                type: type,
                is_client: this.isClient,
            }
            const queryString = Object.keys(data)
            .map(key => key + "=" + data[key])
            .join("&");

            window.location = endpoint + "?" + queryString;
            this.disabled = false;
        }
    }
}


</script>

<style scoped>
    button[disabled="disabled"] {
        opacity: 0.4;
        cursor: initial;
    }
</style>